import React from 'react'
import { transactionTimeStamp } from '../../../utils'
import EyeIcon from '../icons/EyeIcon'

const NotificationCard = ({notification}) => {
  return (
    <div className='p-4 rounded-[8px] bg-white my-5 relative border'>
      <div className={`absolute top-[10px] left-[10px] w-[6px] h-[6px] rounded-full ${notification.read ? 'bg-gray-300' : 'bg-red-500'}`}></div>

      <button className='absolute top-[10px] right-[10px] p-2 rounded bg-gray-100 text-gray-400 hover:text-vcm-purple transition duration-200 active:bg-white'>
        <EyeIcon className={`w-4 h-4`} />
      </button>

      <div className='mt-1 pl-[15px]'>
        <p className='text-sm font-[500] text-gray-800'>{notification.title}</p>
        <p className='text-xs font-[400] text-gray-800 mt-1'>{transactionTimeStamp(notification.date).date} - {transactionTimeStamp(notification.date).time}</p>
        <p className='text-sm font-[400] text-gray-500'>{notification.message}</p>

      </div>
    </div>
  )
}

export default NotificationCard